module.exports = __webpack_public_path__ + "img/alert.f7609b16.svg";